import * as React from 'react'
import { useMemo } from 'react'

import type { CustomFieldProps } from './typings'
import { AdditionalInfoListItem } from '@sales-center/components'
import type { CustomFieldNumberValue } from '@sales-center/common'

type CustomNumberProps = CustomFieldProps & {
  value: CustomFieldNumberValue
}

export function CustomNumber(props: CustomNumberProps) {
  const {
    customFields,
    value: { customFieldId, number },
  } = props

  const thisField = useMemo(
    () => customFields.find((x) => x.id === customFieldId),
    [customFieldId, customFields],
  )

  if (!thisField) return null

  const subtitle = (number ?? '').toString()

  return <AdditionalInfoListItem title={thisField.name} subtitle={subtitle} />
}
